const minValue = -20
const maxValue = 20

const bidimensionalChartOptions = (tooltipDatasets, axisTitles) => {
  return {
    animation: {
      duration: 0
    },
    elements: elementsConfig(),
    maintainAspectRatio: false,
    interaction: {
      mode: 'index'
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        bodyFont: {
          size: 12,
          weight: '600',
          family: 'Mont'
        },
        callbacks: {
          title: (context) => {
            return `${context[0].dataIndex / 30} s`
          },
          label: (context) => {
            const originalValue = tooltipDatasets[context.datasetIndex].data[context.dataIndex]
            return [
              ` A/P ${originalValue.y} cm`,
              ` M/L ${originalValue.x} cm`
            ]
          }
        },
        usePointStyle: true
      }
    },
    responsive: true,
    scales: {
      x: {
        grid: {
          color: function(context) {
            if(context.tick.label == '0') {
              return "rgba(119, 139, 161, 0.8)"
            }
            return 'rgba(78, 94, 112, 0.6)'
          }
        },
        ticks: {
          callback: function(value) {
            const label = this.getLabelForValue(value)
            if(label % 5 == 0) {
              return label
            }
          },
          color: '#778BA1',
          font: fontConfig()
        },
        title: {
          align: 'center',
          color: '#778BA1',
          display: true,
          font: fontConfig(),
          text: axisTitles[0]
        }
      },
      y: {
        afterDataLimits(axis) {
          axis.max += 1;
        },
        grid: {
          color: function(context) {
            if(context.tick.label == '0') {
              return "rgba(119, 139, 161, 0.8)"
            }
            return 'rgba(78, 94, 112, 0.6)'
          }
        },
        max: maxValue,
        min: minValue,
        ticks: {
          callback: function(value) {
            const label = this.getLabelForValue(value)
            if(parseInt(label) % 5 == 0) {
              return label
            }
          },
          color: '#778BA1',
          font: fontConfig()
        },
        title: {
          align: 'center',
          color: '#778BA1',
          display: true,
          font: fontConfig(),
          text: axisTitles[1]
        }
      }
    }
  }
}

const drawVerticalLineOnHover = (chart) => {
  if(chart.tooltip._active && chart.tooltip._active.length) {
    const ctx = chart.ctx
    ctx.save()
    const activePoint = chart.tooltip._active[0]
    ctx.beginPath()
    ctx.moveTo(activePoint.element.x, chart.chartArea.top)
    ctx.lineTo(activePoint.element.x, chart.chartArea.bottom)
    ctx.lineWidth = 2
    ctx.strokeStyle = 'white'
    ctx.stroke()
    ctx.restore()
  }
}

const elementsConfig = () => {
  return {
    line: {
      borderWidth: 1
    },
    point: {
      radius: 0
    }
  }
}

const fontConfig = () => {
  return {
    family: 'Mont',
    size: 11,
    weight: '600'
  }
}

const gridConfig = () => {
  return {
    color: (context) => {
      if(context.tick.value == 0) {
        return "rgba(119, 139, 161, 0.8)"
      }
      return 'rgba(78, 94, 112, 0.6)'
    }
  }
}

const monodimensionalChartOptions = (tooltipDatasets) => {
  return {
    animation: {
      duration: 0
    },
    elements: elementsConfig(),
    interaction: {
      intersect: false,
      mode: 'index'
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        bodyFont: {
          family: 'Mont',
          size: 12,
          weight: '600'
        },
        usePointStyle: true,
        callbacks: {
          title: (context) => {
            return `${context[0].label} s`
          },
          label: (context) => {
            const originalValue = tooltipDatasets[context.datasetIndex].data[context.dataIndex].y
            return ` ${originalValue} cm`
          }
        }
      }
    },
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
        grid: gridConfig(),
        ticks: {
          beginAtZero: true,
          callback: function(value) {
            if (value % 60 == 0) {
              return `${ value / 30 }`
            }
          },
          color: '#778BA1',
          font: fontConfig()
        }
      },
      y: {
        afterDataLimits(axis) {
          axis.max += 1;
        },
        max: maxValue,
        min: minValue,
        grid: gridConfig(),
        ticks: {
          color: '#778BA1',
          font: fontConfig()
        }
      }
    }
  }
}

export const monodimensionalChart = (canvas, datasets, labels, tooltipDatasets) => {
  return new Chart4(canvas, {
    type: 'line',
    data: {
      labels: labels,
      datasets: datasets
    },
    options: monodimensionalChartOptions(tooltipDatasets),
    plugins: [{
      afterDatasetsDraw: (chart) => {
        drawVerticalLineOnHover(chart)
      }
    }]
  })
}

export const bidimensionalChart = (canvas, datasets, labels, tooltipDatasets, axisTitles) => {
  return new Chart4(canvas, {
    type: 'line',
    data: {
      labels: labels,
      datasets: datasets
    },
    options: bidimensionalChartOptions(tooltipDatasets, axisTitles)
  })
}